// @flow
import spacing from './constants/spacing'
import type { SpacingSize } from './constants/spacing'

const margin = (size: SpacingSize) => ({ margin: spacing(size) })
margin.top = (size: SpacingSize) => ({ marginTop: spacing(size) })
margin.right = (size: SpacingSize) => ({ marginRight: spacing(size) })
margin.bottom = (size: SpacingSize) => ({ marginBottom: spacing(size) })
margin.left = (size: SpacingSize) => ({ marginLeft: spacing(size) })
margin.x = (size: SpacingSize | 'auto') => {
  if (size === 'auto') {
    return { marginLeft: size, marginRight: size }
  }

  return { marginLeft: spacing(size), marginRight: spacing(size) }
}
margin.y = (size: SpacingSize) => ({
  marginTop: spacing(size),
  marginBottom: spacing(size),
})

export default margin



// WEBPACK FOOTER //
// ./src/style/margin.js